<ion-content class="background ion-no-padding ion-text-center">
    <!-- <pre>{{ vm.customer | json }}</pre>
    <pre>{{ vm.incentives | json }}</pre> -->
    <div scrollY="true" style="height: 10000px">
        <ion-grid>
            @if (vm.title || vm.subtitle) {
  <ion-label class="ion-text-center ion-padding">
                @if (vm.title) {
  <h1>{{doReplacements(vm.title)}}</h1>
}
                @if (vm.subtitle) {
  <p>{{doReplacements(vm.subtitle)}}</p>
}
            </ion-label>
}

            <ion-row>
                <ion-col>
                    @for (incentive of vm.incentives; track $index) {
  <ion-card class="default">
                        @if (incentive.title) {
  <ion-card-header color="medium">
                            @if (incentive.title) {
  <ion-card-title>{{incentive.title}}</ion-card-title>
}
                        </ion-card-header>
}

                        <ion-card-content class="ion-no-padding">
                            @if (incentive.line1) {
  <div>
                                @if (incentive.line1) {
  <h1 class="bold big">{{incentive.line1}}</h1>
}
                                <br />    
                            </div>
}

                            <!-- @if (incentive.line1) {
  <h1 class="bold big">{{incentive.line1}}</h1>
}
                            <br /> -->
                            @if (incentive.line2 || incentive.line3 || incentive.line4) {
  <div>
                                <h1 class="bold">{{incentive.line2}}</h1>
                                <h1 class="bold">{{incentive.line3}}</h1>
                                <h1 class="bold">{{incentive.line4}}</h1>
                                <br />                                
                            </div>
}

                            <!-- @if (incentive.line2) {
  <h1 class="bold">{{incentive.line2}}</h1>
}
                            @if (incentive.line3) {
  <h1 class="bold">{{incentive.line3}}</h1>
}
                            @if (incentive.line4) {
  <h1 class="bold">{{incentive.line4}}</h1>
}
                            <br /> -->
                            @if (incentive.line5) {
  <h2 class="normal">{{incentive.line5}}</h2>
}
                            @if (incentive.line6) {
  <h2 class="normal">{{incentive.line6}}</h2>
}
                            <!-- @if (incentive.line7) {
  <h2 class="normal lastLine">{{incentive.line7}}</h2>
} -->
                            @if (incentive.line7) {
  <h2 class="normal ion-margin-bottom">{{incentive.line7}}</h2>
}

                            <!-- @if (incentive.line5) {
  <h2 class="normal">{{incentive.line5}}</h2>
}
                            @if (incentive.line6) {
  <h2 class="normal">{{incentive.line6}}</h2>
}
                            @if (incentive.line7) {
  <h2 class="normal">{{incentive.line7}}</h2>
} -->
                            <!-- @if (incentive.note) {
  <h2 class="normal ion-text-start note">{{incentive.note}}</h2>
} -->

                            @if (incentive.note) {
  <h2 class="normal ion-margin-bottom ion-text-start note">{{incentive.note}}</h2>
}                        

                        </ion-card-content>

                        @if (incentive.showCallButton) {
  <div class="card-footer">
                            <ion-row>
                                <ion-col>
                                    <ion-button data-test="callButton" class="ion-no-padding" expand="full" (click)="onPhoneNumberClick()">
                                        {{incentive.buttonText}}
                                        <ion-icon slot="end" name="call"></ion-icon>
                                    </ion-button>
                                </ion-col>
                            </ion-row>
                        </div>
}
                    </ion-card>
}
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
    <a id="phoneCaller" target="_self"></a>
</ion-content>
